import { privateAxios } from '@/common/api/axios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseGeneralDocumentsProps<T> = {
  filters?: {
    page?: number
    search?: string
    clientBranchId?: string
    establishmentCompanyId?: string
    establishmentBranchId?: string
  }
  mapper?: (data: any) => T
}

export const useGeneralDocuments = <T,>({
  filters: { page, search } = {},
  mapper = Mapper.default<T>(),
}: UseGeneralDocumentsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['generalDocuments', page, search],
    queryFn: () => {
      return privateAxios.get('/general_documents', {
        params: {
          page,
          search,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(data?.data?.data),
      meta: data?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
